const guiColors = {
    'looks-secondary': '#4fc3f7',
    'looks-transparent': 'rgba(79, 195, 247, 0.35)',
    'looks-light-transparent': 'rgba(79, 195, 247, 0.15)',
    'looks-secondary-dark': '#039be5'
};

const blockColors = {};

export {
    guiColors,
    blockColors
};
